import { motion } from "framer-motion";

export function ClientsSection() {
  const clients = [
    { name: "TechGear VN", logo: "TG" },
    { name: "ProBeauty", logo: "PB" },
    { name: "Café Bông Sen", logo: "BS" },
    { name: "ShopNhanh", logo: "SN" },
    { name: "ProK", logo: "PK" }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Clients & Partners
          </h2>
          <div className="w-16 h-1 bg-gradient-to-r from-orange-500 to-orange-700 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            Trusted by leading brands across industries
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="relative overflow-hidden"
        >
          <motion.div
            animate={{ x: [0, -100 * clients.length] }}
            transition={{
              duration: 20,
              repeat: Infinity,
              ease: "linear"
            }}
            className="flex space-x-16"
            style={{ width: `${200 * clients.length}%` }}
          >
            {[...clients, ...clients, ...clients].map((client, index) => (
              <div
                key={`${client.name}-${index}`}
                className="flex-shrink-0 bg-orange-50 rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300 flex items-center justify-center min-w-[200px] h-24"
              >
                <div className="text-center">
                  <div className="bg-gradient-to-r from-orange-600 to-orange-700 text-white rounded-lg w-12 h-12 flex items-center justify-center mx-auto mb-2">
                    <span className="font-bold text-lg">{client.logo}</span>
                  </div>
                  <span className="text-gray-700 font-medium text-sm">{client.name}</span>
                </div>
              </div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}